import { useSendPlatformMail } from "@/api";
import { toast } from "@/components/ui/use-toast";
import { EmailNotificationCategory, Role } from "@/gql/__generated__/graphql";
import { getFormData } from "@/lib/js-helpers/getFormData";
import { FormEvent, useState } from "react";

export const TEST_MAIL_NAME_ATTRIBUTE = "submitTest";

export function useHandleSubmit() {
  const [sendPlatformMail] = useSendPlatformMail();

  const [loading, setLoading] = useState(false);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const isTestMail =
      (e.nativeEvent as SubmitEvent).submitter?.getAttribute("name") ===
      TEST_MAIL_NAME_ATTRIBUTE;
    const { sendGridTemplateID, emailCategory, userType } = getFormData(
      e.currentTarget,
      ["sendGridTemplateID", "emailCategory", "userType"] as const
    );

    if (!sendGridTemplateID || !emailCategory || !userType)
      toast({
        title: "Missing inputs",
        description: "Please fill out all inputs to send mails"
      });

    setLoading(true);

    sendPlatformMail({
      variables: {
        sendGridTemplateID: sendGridTemplateID as string,
        emailCategory: emailCategory as EmailNotificationCategory,
        userType: userType as Role,
        testMail: isTestMail
      }
    })
      .then((res) => {
        if (res.data?.sendPlatformMail?.__typename !== "PlatformMail") {
          toast({
            title: "Unable to send mails",
            description:
              "An error occurred while trying to send platform mails. Please check the logs."
          });
          console.error(res.errors);
        } else {
          const { to, testMail } = res.data.sendPlatformMail;
          const description = testMail
            ? `Test mail sent to ${to[0]}`
            : `Platform mail sent to ${to.length} recepient${to.length === 1 ? "" : "s"}`;

          toast({
            title: `Platform mail${to.length === 1 ? "" : "s"} sent`,
            description
          });
        }
      })
      .catch((error) => {
        toast({
          title: "Unable to send mails",
          description:
            "An error occurred while trying to send platform mails. Please check the logs."
        });
        console.error(error);
      })
      .finally(() => setLoading(false));
  }

  return { handleSubmit, loading };
}
